export interface TotmOrder {
  surfLessonsEasy: number
  surfLessonsHard: number
}

export const initialTotmOrder: TotmOrder = {
  surfLessonsEasy: 0,
  surfLessonsHard: 0,
}
